export const TAX_RATES_REQUESTED = 'TAX_RATES_REQUESTED'
export const TAX_RATES_RECEIVED = 'TAX_RATES_RECEIVED'
